module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/wedding-mobile-9817f4ff7c7817af876b38b2bbd68fee.jpg";